import script from "./ProductAddOnTile.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductAddOnTile.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__